import { generateClient } from 'aws-amplify/api';
import './appsyncClient';

const TRANSCRIPTION_ENDPOINT =
  process.env.REACT_APP_TRANSCRIPTION_APPSYNC_ENDPOINT;
const TRANSCRIPTION_REGION =
  process.env.REACT_APP_TRANSCRIPTION_APPSYNC_REGION;
const TRANSCRIPTION_API_KEY =
  process.env.REACT_APP_TRANSCRIPTION_APPSYNC_API_KEY;

if (!TRANSCRIPTION_ENDPOINT || !TRANSCRIPTION_REGION || !TRANSCRIPTION_API_KEY) {
  throw new Error(
    'Missing transcription AppSync env vars. Set REACT_APP_TRANSCRIPTION_APPSYNC_ENDPOINT, REACT_APP_TRANSCRIPTION_APPSYNC_REGION, and REACT_APP_TRANSCRIPTION_APPSYNC_API_KEY.'
  );
}

export const transcriptionClient = generateClient({
  endpoint: TRANSCRIPTION_ENDPOINT,
  region: TRANSCRIPTION_REGION,
  authMode: 'apiKey',
  apiKey: TRANSCRIPTION_API_KEY,
});
